module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lh7dB"))).then(() => parcelRequire('f4eak'));